export const ItemTypes = {
  ON_DEMAND_WORKOUT: 'onDemandWorkout',
};
